<template>
	<a v-if="to" v-bind:href="to" class="btn btn-primary btn--icon-r">
		<span v-html="text"></span>
		<span class="btn--icon__icon d-none d-md-inline">
			<RightArrow />
		</span>
	</a>
	<a v-else href="" class="btn btn-primary btn--icon-r">
		<span v-html="text"></span>
		<span class="btn--icon__icon d-none d-md-inline">
			<RightArrow />
		</span>
	</a>
</template>
<script>
import RightArrow from "@/components/icons/RightArrow.vue";

export default {
	name: 'Arrowlink',
	components: {
		RightArrow
	},
	props: ['text', 'to']
};
</script>
